module.exports = __webpack_public_path__ + "static/the-tao-of-leadership-b50fee673fa924b16496e1afc11a1650.jpg";